<template>
  <div>
    <div class="slider-item-container">
      <ImageView
        :source="data.coverImage"
        :imageSize="thumborSize" />
      <div class="title-container" v-if="useOverlay">
        <h2 class="title">{{data.title}}</h2>
        <div class="content-category" :class="getContentCategoryKey()">
          {{getContentCategoryName()}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ImageView from '@/image/ImageView.vue';

export default {
  components: {
    ImageView,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    thumborSize: {
      type: String,
      default: 'cover1280w720h',
    },
    useOverlay: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getContentCategoryName() {
      return _.get(this.data, 'contentCategory.name', '');
    },
    getContentCategoryKey() {
      return _.get(this.data, 'contentCategory.key', '');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.slider-item-container {
  position: relative;
  .title-container{
    color: white;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(transparent, rgba(darken($primary, 5%), 0.8) 30%);
    padding: $spacer * 3.5 $spacer  $spacer * 3 $spacer;
    .title {
      font-family: $font-family-DBHeavent;
      font-weight: 500;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .content-category {
      font-family: $font-family-DBHeavent;
      font-weight: 500;
      font-size: $font-size-base * 1.5;
    }
  }
  .smart-classroom {
    color: $altv-red;
  }
  .active-learning-news {
    color: $primary-100;
  }
  .knowledge-pool {
    color: $altv-blue;
  }
  .homeroom-homerun {
    color: $altv-orange;
  }
  .activity {
    color: $altv-mint;
  }
  .tutor-hub {
    color: $altv-pink;
  }
}

@media (max-width: 575.98px) {
  .slider-item-container {
    .title-container {
      padding: $spacer * 2 $spacer  $spacer * 2 $spacer;
      .title {
        font-size: $font-size-base * 1.5;
      }
    }
  }
}

</style>
